// The admin console credentials: the engine API base URL and the admin access code (the
// ADMIN_TOKENS bearer token). Held in sessionStorage so a refresh keeps you signed in but
// closing the tab signs you out. This is a LOCAL dev gate; Cloudflare Access replaces it at
// cutover (the token stops being user-entered and becomes a verified staff identity).
export interface Creds {
  baseUrl: string;
  token: string;
}

const KEY = 'hydrus_admin_creds';

export function defaultBaseUrl(): string {
  const fromEnv = import.meta.env.VITE_API_URL as string | undefined;
  return (fromEnv && fromEnv.trim()) || 'http://localhost:8787';
}

export function getCreds(): Creds | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const c = JSON.parse(raw) as Creds;
    return c.baseUrl && c.token ? c : null;
  } catch {
    return null;
  }
}

export function setCreds(c: Creds): void {
  sessionStorage.setItem(KEY, JSON.stringify(c));
}

export function clearCreds(): void {
  sessionStorage.removeItem(KEY);
}
